module.exports = __webpack_public_path__ + "img/germany-shape.95c21d2.svg";